<template>
  <div class="user-login-wrap">
    <div class="user-login">
      <div class="is-login-box" v-if="isLogin">
        <el-badge
          :max="99"
          :value="msgNumber.bell_msg"
          :hidden="!msgNumber.bell_msg"
        >
          <span
            class="icon-btn el-icon-bell"
            @click.stop="navigateToMsg('interact')"
          ></span>
        </el-badge>
        <el-badge
          :max="99"
          :value="msgNumber.chat_msg"
          :hidden="!msgNumber.chat_msg"
          ><span
            class="icon-btn el-icon-chat-dot-square"
            @click.stop="navigateToMsg('private')"
          ></span
        ></el-badge>
        <el-dropdown @command="command" class="nav-user-popper">
          <p-img
            class="login-avatar"
            font-size="0px"
            :src="$store.getters.avatar"
          />
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="user" icon="el-icon-user"
              >个人中心</el-dropdown-item
            >
            <el-dropdown-item command="account" icon="el-icon-folder-opened"
              >账号信息</el-dropdown-item
            >
            <el-dropdown-item command="privacy" icon="el-icon-setting"
              >隐私设置</el-dropdown-item
            >
            <el-dropdown-item command="exit" icon="el-icon-switch-button"
              >安全退出</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="not-login-box" v-else>
        <el-button
          round
          type="primary"
          :size="$elsize"
          @click="loginVisible = true"
        >
          登录 / 注册
        </el-button>
      </div>
    </div>
    <Login
      :visible="loginVisible"
      visible-key="loginVisible"
      @switchModal="switchModal"
      @afterLogin="afterLogin"
    ></Login>
    <Keyword
      :visible="keywordVisible"
      visible-key="keywordVisible"
      @confirm="confirm"
      @switchModal="switchModal"
    />
  </div>
</template>
<script>
import Login from "@/components/login/Index";
import Keyword from "@/components/keyword/Index";
import { mapActions } from "vuex";
export default {
  name: "user-login",
  components: { Login, Keyword },
  data: function () {
    const { token } = this.$store.getters;
    return {
      token,
      loginVisible: false,
      keywordVisible: false,
      // msgNumber: {},
      msgNumberTimer: null,
    };
  },
  computed: {
    msgNumber() {
      return this.$store.getters.msgNumber;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },
  methods: {
    ...mapActions("user", ["logout", "fetchMsgNumber"]),
    switchModal(field, val) {
      if (typeof val == "boolean") return (this[field] = val);
      this[field] = false;
    },
    confirm() {
      this.keywordVisible = false;
      location.reload();
    },
    showLogin() {
      this.loginVisible = true;
    },
    afterLogin(newUser) {
      newUser && (this.keywordVisible = true);
      this.$nextTick(() => (this.loginVisible = false));
    },
    /* 跳转到消息中心页面   */
    navigateToMsg(enu) {
      const pathMap = new Map([
        ["system", "/msg/system"],
        ["interact", "/msg/interact"],
        ["private", "/msg/private"],
      ]);
      const path = pathMap.get(enu);
      path && this.$router.push(path);
    },
    command(command) {
      const { path } = this.$route;
      const toPathMap = new Map([
        ["privacy", "/privacy-setting"],
        ["user", "/personal/index"],
        ["account", "/user/account"],
      ]);
      const toPath = toPathMap.get(command);
      toPath && toPath !== path && this.$router.push(toPath);
      if (command == "exit")
        return this.logout({ cb: () => location.reload() });
    },
    startMsgNumberTimer() {
      this.$nextTick(() => {
        if (!this.token) return;
        this.fetchMsgNumber(); // 先执行一次
        this.msgNumberTimer = setInterval(this.fetchMsgNumber, 25000);
      });
    },
    clearMsgNumberTimer() {
      this.msgNumberTimer && clearInterval(this.msgNumberTimer);
      this.msgNumberTimer = null;
    },
  },
  created() {
    this.startMsgNumberTimer();
    // this.fetchMsgNumber();
    this.$bus.$on("showLogin", this.showLogin);
  },
  beforeDestroy() {
    this.clearMsgNumberTimer();
    this.$bus.$off("showLogin", this.showLogin);
  },
};
</script>

<style lang="scss" scoped>
.el-dropdown-menu.el-popper {
  z-index: 10086 !important;
}
.user-login-wrap {
  .user-login {
    text-align: right;
    .is-login-box {
      display: flex;
      gap: 24px;
    }
    .icon-btn {
      display: inline-block;
      font-size: 20px;
      color: var(--color-info);
      transition: all 0.4s;
      &:hover {
        color: var(--color-primary);
        cursor: pointer;
      }
    }
    .is-login-box {
      display: flex;
      align-items: center;
      .login-avatar {
        width: 32px;
        height: 32px;
        border-radius: 5px;
        cursor: pointer;
      }
    }
  }
}
</style>
